/* Stories vidéo de la home (FR), 28/09/2026. Carte = bouton avec une affiche ; AUCUNE vidéo avant le clic.
   Au 1er clic : un <dialog> est ajouté à <body> avec UN seul <video>, qui lit la story avec le son (dans le geste du clic,
   iPhone compris) puis enchaîne les suivantes. Sans dépendance. Source : VIDEOS-SITE-REFONTE-2026-09-27/integration-home/. */
(function () {
  'use strict';
  var root = document.getElementById('mng-stories');
  if (!root || root.getAttribute('data-ok')) return;
  root.setAttribute('data-ok', '1');

  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function joue(v, siRefus) {
    var p;
    try { p = v.play(); } catch (e) { if (siRefus) siRefus(e); else console.error('[stories] lecture', e); return; }
    if (p && p.catch) p.catch(function (e) {
      if (e && e.name === 'AbortError') return;             /* source changée pendant le démarrage : normal */
      if (siRefus) siRefus(e); else console.error('[stories] lecture', e);
    });
  }

  var SVG = {
    son: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z" fill="currentColor"/><path d="M15.5 8.5a5 5 0 0 1 0 7M18 6a8.5 8.5 0 0 1 0 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    muet: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z" fill="currentColor"/><path d="M16 9.5l5 5M21 9.5l-5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    pause: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="5" width="4.2" height="14" rx="1.2" fill="currentColor"/><rect x="13.8" y="5" width="4.2" height="14" rx="1.2" fill="currentColor"/></svg>',
    play: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.2v13.6a1 1 0 0 0 1.5.86l11-6.8a1 1 0 0 0 0-1.72l-11-6.8A1 1 0 0 0 8 5.2z" fill="currentColor"/></svg>',
    croix: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
    g: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    d: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  /* ---------- données : lues sur les cartes (une ligne du snippet = une carte) ---------- */
  var cartes = $$('.mngst-card', root);
  var L = cartes.map(function (c) {
    return { id: c.getAttribute('data-id'), src: c.getAttribute('data-src'), poster: c.getAttribute('data-poster'),
      nom: c.getAttribute('data-nom') || '', role: c.getAttribute('data-role') || '', q: c.getAttribute('data-q') || '',
      cite: c.getAttribute('data-cite') === 'q' };
  });
  if (!L.length) return;

  /* ---------- déjà vues (anneau gris), mémoire de l'onglet seulement ---------- */
  var vues = [];
  try { vues = JSON.parse(sessionStorage.getItem('mng-stories-vues') || '[]') || []; } catch (e) { vues = []; }
  function marqueVue(id) {
    if (vues.indexOf(id) < 0) vues.push(id);
    try { sessionStorage.setItem('mng-stories-vues', JSON.stringify(vues)); } catch (e) { /* stockage indisponible : l'anneau reste coloré */ }
  }
  function peintVues() { cartes.forEach(function (c) { c.classList.toggle('vu', vues.indexOf(c.getAttribute('data-id')) >= 0); }); }
  peintVues();

  /* ---------- carrousel ---------- */
  var rail = $('.mngst-rail', root), fg = $('.mngst-g', root), fd = $('.mngst-d', root);
  function pas() { var it = $('.mngst-it', rail); return it ? (it.getBoundingClientRect().width + 14) * 2 : 300; }
  function fleches() {
    if (!rail) return;
    if (fg) fg.disabled = rail.scrollLeft < 8;
    if (fd) fd.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 8;
  }
  if (rail) {
    if (fg) fg.addEventListener('click', function () { rail.scrollBy({ left: -pas(), behavior: reduce.matches ? 'auto' : 'smooth' }); });
    if (fd) fd.addEventListener('click', function () { rail.scrollBy({ left: pas(), behavior: reduce.matches ? 'auto' : 'smooth' }); });
    rail.addEventListener('scroll', fleches, { passive: true });
    window.addEventListener('resize', fleches);
    fleches();
  }
  cartes.forEach(function (c, k) { c.addEventListener('click', function () { ouvre(k, c); }); });

  /* ---------- lecteur : construit au 1er clic seulement ---------- */
  var sp, v, stage, bars, nomB, roleS, qEl, bg, muteB, pauseB, hint, live, fin, peekP, peekN, barres = [];
  var S = { i: 0, ouvert: false, muet: false, source: null, histo: false, raf: 0, apres: null };
  var modal = false;

  function construit() {
    sp = document.createElement('dialog');
    sp.className = 'mngsp';
    sp.setAttribute('aria-label', 'Vidéos clients');
    sp.innerHTML =
      '<div class="mngsp-bg" aria-hidden="true"></div>' +
      '<div class="mngsp-side g"><button class="mngsp-peek mngsp-peek-p" type="button" aria-label="Vidéo précédente"><img alt="" width="150" height="267"></button><button class="mngsp-ib mngsp-prev" type="button" aria-label="Vidéo précédente">' + SVG.g + '</button></div>' +
      '<div class="mngsp-stage">' +
        '<video playsinline webkit-playsinline preload="none" disablepictureinpicture></video>' +
        '<span class="mngsp-load" aria-hidden="true"></span><span class="mngsp-paused" aria-hidden="true">' + SVG.play + '</span>' +
        '<div class="mngsp-top"><div class="mngsp-bars" aria-hidden="true"></div><div class="mngsp-row"><p class="mngsp-name"><b></b><span></span></p>' +
          '<button class="mngsp-ib mngsp-pause" type="button" aria-label="Pause">' + SVG.pause + '</button>' +
          '<button class="mngsp-ib mngsp-mute" type="button" aria-label="Couper le son">' + SVG.son + '</button>' +
          '<button class="mngsp-ib mngsp-close" type="button" aria-label="Fermer">' + SVG.croix + '</button></div></div>' +
        '<button class="mngsp-hint" type="button" hidden>' + SVG.son + 'Touchez pour le son</button>' +
        '<div class="mngsp-bot"><p class="mngsp-q"></p><a class="mngsp-cta" href="#poudre">Découvrir Brainstoorm</a></div>' +
        '<div class="mngsp-end" hidden><b>Vous avez tout vu&nbsp;!</b><a class="mngsp-cta" href="#poudre">Découvrir Brainstoorm</a><button class="mngsp-again" type="button">Revoir depuis le début</button></div>' +
      '</div>' +
      '<div class="mngsp-side d"><button class="mngsp-peek mngsp-peek-n" type="button" aria-label="Vidéo suivante"><img alt="" width="150" height="267"></button><button class="mngsp-ib mngsp-next" type="button" aria-label="Vidéo suivante">' + SVG.d + '</button></div>' +
      '<button class="mngsp-ib mngsp-x mngsp-close2" type="button" aria-label="Fermer">' + SVG.croix + '</button>' +
      '<p class="mngsp-sr" aria-live="polite"></p>';
    document.body.appendChild(sp);
    modal = typeof sp.showModal === 'function';
    v = $('video', sp); stage = $('.mngsp-stage', sp); bars = $('.mngsp-bars', sp); bg = $('.mngsp-bg', sp);
    nomB = $('.mngsp-name b', sp); roleS = $('.mngsp-name span', sp); qEl = $('.mngsp-q', sp);
    muteB = $('.mngsp-mute', sp); pauseB = $('.mngsp-pause', sp); hint = $('.mngsp-hint', sp); live = $('.mngsp-sr', sp); fin = $('.mngsp-end', sp);
    peekP = $('.mngsp-peek-p img', sp); peekN = $('.mngsp-peek-n img', sp);
    bars.innerHTML = L.map(function () { return '<i><b></b></i>'; }).join('');
    barres = $$('b', bars);

    v.addEventListener('ended', suivante);
    v.addEventListener('waiting', function () { sp.classList.add('wait'); });
    v.addEventListener('playing', function () { sp.classList.remove('wait'); etatPause(); });
    v.addEventListener('pause', etatPause);
    v.addEventListener('play', etatPause);
    v.addEventListener('error', function () {
      if (v.getAttribute('src')) { sp.classList.remove('wait'); console.error('[stories] fichier illisible', v.currentSrc, v.error); }
    });
    pauseB.addEventListener('click', bascule);
    muteB.addEventListener('click', basculeSon);
    hint.addEventListener('click', basculeSon);
    $$('.mngsp-close, .mngsp-close2', sp).forEach(function (b) { b.addEventListener('click', function () { ferme(); }); });
    $('.mngsp-prev', sp).addEventListener('click', precedente);
    $('.mngsp-next', sp).addEventListener('click', suivante);
    $('.mngsp-peek-p', sp).addEventListener('click', precedente);
    $('.mngsp-peek-n', sp).addEventListener('click', suivante);
    $('.mngsp-again', sp).addEventListener('click', function () { charge(0); });
    $$('.mngsp-cta', sp).forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        ferme(function () {
          var cible = document.getElementById('poudre');
          if (cible) cible.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
        });
      });
    });
    sp.addEventListener('cancel', function (e) { e.preventDefault(); ferme(); });   /* Échap */
    sp.addEventListener('click', function (e) { if (e.target === sp || e.target === bg) ferme(); });
    window.addEventListener('popstate', function () { if (S.ouvert) { S.histo = false; fermeUI(); } });

    /* toucher : gauche = précédente, droite = suivante, centre = pause, appui long = pause tenue, glisser = changer ou fermer */
    var t = { x: null, y: 0, tenu: false, minuterie: 0 };
    stage.addEventListener('pointerdown', function (e) {
      if (e.button > 0 || e.target.closest('button, a, .mngsp-end')) return;
      t.x = e.clientX; t.y = e.clientY; t.tenu = false;
      clearTimeout(t.minuterie);
      t.minuterie = setTimeout(function () { t.tenu = true; sp.classList.add('held'); v.pause(); }, 260);
    });
    function finGeste(e, annule) {
      clearTimeout(t.minuterie);
      if (t.x === null) return;
      var dx = e.clientX - t.x, dy = e.clientY - t.y; t.x = null;
      if (t.tenu) { t.tenu = false; sp.classList.remove('held'); lecture(); return; }
      if (annule) return;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) suivante(); else precedente(); return; }
      if (dy > 90 && Math.abs(dy) > Math.abs(dx)) { ferme(); return; }
      if (Math.abs(dx) > 12 || Math.abs(dy) > 12) return;
      var r = stage.getBoundingClientRect(), x = (e.clientX - r.left) / r.width;
      if (x < 0.3) precedente(); else if (x > 0.7) suivante(); else bascule();
    }
    stage.addEventListener('pointerup', function (e) { finGeste(e, false); });
    stage.addEventListener('pointercancel', function (e) { finGeste(e, true); });
    stage.addEventListener('contextmenu', function (e) { e.preventDefault(); });

    sp.addEventListener('keydown', function (e) {
      if (!S.ouvert) return;
      var k = e.key;
      if (k === 'ArrowRight') { e.preventDefault(); suivante(); }
      else if (k === 'ArrowLeft') { e.preventDefault(); precedente(); }
      else if (k === 'k' || k === 'K' || (k === ' ' && !/^(BUTTON|A)$/.test(e.target.tagName))) { e.preventDefault(); bascule(); }
      else if (k === 'm' || k === 'M') { basculeSon(); }
      else if (k === 'Escape' && !modal) { e.preventDefault(); ferme(); }
      else if (k === 'Tab') {
        var f = $$('button, a[href]', sp).filter(function (el) { return el.offsetParent !== null && !el.closest('[hidden]'); });
        if (!f.length) return;
        var i = f.indexOf(document.activeElement);
        if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && (i === f.length - 1 || i < 0)) { e.preventDefault(); f[0].focus(); }
      }
    });
    son();
  }

  function son() {
    muteB.innerHTML = S.muet ? SVG.muet : SVG.son;
    muteB.setAttribute('aria-label', S.muet ? 'Activer le son' : 'Couper le son');
  }
  function etatPause() {
    var p = v.paused && !v.ended;
    sp.classList.toggle('pause', p && S.ouvert && fin.hidden && !sp.classList.contains('held'));
    pauseB.innerHTML = p ? SVG.play : SVG.pause;
    pauseB.setAttribute('aria-label', p ? 'Lecture' : 'Pause');
  }
  function lecture() {
    v.muted = S.muet;
    joue(v, function (e) {
      if (e && e.name === 'NotAllowedError' && !v.muted) {
        /* le navigateur a refusé le son : lecture en muet, bouton pour l'activer */
        S.muet = true; v.muted = true; son(); hint.hidden = false; joue(v);
      } else { console.error('[stories] lecteur', e); }
    });
  }
  function charge(i) {
    S.i = i; var d = L[i];
    fin.hidden = true; if (!S.muet) hint.hidden = true;
    v.poster = d.poster; v.src = d.src;
    bg.style.backgroundImage = 'url("' + d.poster + '")';
    nomB.textContent = d.nom; roleS.textContent = d.role;
    qEl.textContent = d.q; qEl.classList.toggle('cite', d.cite);
    v.setAttribute('aria-label', 'Vidéo : ' + d.nom + (d.role ? ', ' + d.role : ''));
    barres.forEach(function (b, k) { b.style.transform = 'scaleX(' + (k < i ? 1 : 0) + ')'; });
    var p = L[i - 1], n = L[i + 1];
    peekP.parentNode.parentNode.style.visibility = p ? 'visible' : 'hidden';
    peekN.parentNode.parentNode.style.visibility = n ? 'visible' : 'hidden';
    if (p) peekP.src = p.poster;
    if (n) peekN.src = n.poster;
    live.textContent = 'Vidéo ' + (i + 1) + ' sur ' + L.length + ' : ' + d.nom + (d.role ? ', ' + d.role : '');
    marqueVue(d.id);
    lecture();
  }
  function tic() {
    var b = barres[S.i];
    if (b && v.duration) b.style.transform = 'scaleX(' + Math.min(1, v.currentTime / v.duration) + ')';
    S.raf = requestAnimationFrame(tic);
  }
  function ouvre(i, source) {
    if (!sp) construit();
    if (S.ouvert) { charge(i); return; }
    S.ouvert = true; S.source = source || document.activeElement; S.apres = null;
    if (modal) { try { sp.showModal(); } catch (e) { sp.setAttribute('open', ''); } }
    else { sp.classList.add('mngsp-fb'); sp.setAttribute('open', ''); }
    document.documentElement.classList.add('mngsp-on');
    requestAnimationFrame(function () { sp.classList.add('in'); });
    try { history.pushState({ mngsp: 1 }, ''); S.histo = true; } catch (e) { S.histo = false; }   /* retour du téléphone = fermer ; adresse inchangée */
    charge(i);                                   /* lecture lancée dans le geste du clic : le son passe sur iPhone */
    var x = $('.mngsp-close', sp);
    (x.offsetParent ? x : $('.mngsp-close2', sp)).focus({ preventScroll: true });
    cancelAnimationFrame(S.raf); S.raf = requestAnimationFrame(tic);
  }
  function fermeUI() {
    if (!S.ouvert) return;
    S.ouvert = false;
    v.pause(); v.removeAttribute('src'); v.load();   /* coupe le téléchargement en cours */
    cancelAnimationFrame(S.raf);
    sp.classList.remove('in', 'pause', 'wait', 'held');
    document.documentElement.classList.remove('mngsp-on');
    if (modal && sp.open) { try { sp.close(); } catch (e) { sp.removeAttribute('open'); } }
    else { sp.removeAttribute('open'); sp.classList.remove('mngsp-fb'); }
    peintVues();
    var apres = S.apres; S.apres = null;
    if (apres) requestAnimationFrame(apres);        /* après le retour du focus sur la carte (dialog.close), sinon Chrome annule le défilement */
    else if (S.source && S.source.focus) S.source.focus({ preventScroll: true });
  }
  function ferme(apres) {
    S.apres = apres || null;
    if (S.histo && history.state && history.state.mngsp) { S.histo = false; history.back(); }   /* popstate -> fermeUI */
    else { S.histo = false; fermeUI(); }
  }
  function suivante() {
    if (S.i < L.length - 1) charge(S.i + 1);
    else { v.pause(); fin.hidden = false; etatPause(); $('.mngsp-again', sp).focus({ preventScroll: true }); }
  }
  function precedente() { if (v.currentTime > 3 || S.i === 0) { v.currentTime = 0; lecture(); } else charge(S.i - 1); }
  function bascule() { if (v.paused) lecture(); else v.pause(); }
  function basculeSon() { S.muet = !S.muet; v.muted = S.muet; hint.hidden = true; son(); if (v.paused && !v.ended) lecture(); }
})();
